export default ({ store }) => {
  store.dispatch('getServerTime')
  setInterval(() => {
    store.dispatch('getServerTime')
  }, 60000)
}
